import React from "react";
import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useLang } from "@/context/LanguageContext";
import { T } from "@/content/site";

export default function FAQ() {
  const { t } = useLang();
  return (
    <section id="faq" data-testid="faq-section" className="relative bg-[#0F0F0F] py-[140px] md:py-[180px] border-t border-white/5">
      <div className="mx-auto max-w-[1200px] px-6 md:px-10">
        <div className="grid grid-cols-12 gap-10">
          <div className="col-span-12 md:col-span-5">
            <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="overline mb-8">
              <span className="inline-block w-8 h-px bg-[color:var(--sacrvm-gold)] align-middle mr-3" />
              {t(T.faq.overline)}
            </motion.div>
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1 }}
              className="font-serif text-white text-[36px] md:text-[52px] leading-[1.05] tracking-[-0.01em]"
            >
              {t(T.faq.title)}
            </motion.h2>
          </div>
          <div className="col-span-12 md:col-span-7">
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {T.faq.items.map((f, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="border-white/10">
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i}`}
                    className="text-left font-serif text-white text-[20px] md:text-[24px] py-6 hover:no-underline hover:text-[color:var(--sacrvm-gold)] transition-colors"
                  >
                    {t(f.q)}
                  </AccordionTrigger>
                  <AccordionContent className="text-[color:var(--sacrvm-text-muted)] text-[15px] leading-[1.7] pb-6 pr-6">
                    {t(f.a)}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
